<div
    [ngClass]="{ 'is-expanded': isExpanded(), hidden: notifications().length === 0 }"
    [ngStyle]="{ height: isExpanded() ? 5 + notifications().length * 7 + 'rem' : null }"
    class="course-notification-popup-overlay"
    (click)="overlayClicked()"
>
    @for (notification of notifications(); track notification.notificationId) {
        <div
            class="notification-animation-wrapper"
            animate.enter="notification-entering"
            animate.leave="notification-leaving"
            [ngStyle]="{ bottom: isExpanded() ? (notifications().length - $index - 1) * 7 + 5 + 'rem' : null }"
        >
            <div class="course-notification-popup-overlay-notification">
                <jhi-course-notification
                    [courseNotification]="notification"
                    [isShowClose]="true"
                    [isHideTime]="true"
                    [isRedirectToUrl]="isExpanded() || notifications().length === 1"
                    [displayTimeInMilliseconds]="popupTimeInMilliseconds - 500"
                    (onCloseClicked)="closeClicked(notification)"
                />
            </div>
        </div>
    }

    <div class="course-notification-popup-overlay-collapse">
        <button pButton [outlined]="true" size="small" [rounded]="true" class="me-2" (click)="collapseOverlayClicked()">
            <fa-icon [icon]="faTimes" />
        </button>

        <button pButton [outlined]="true" size="small" [rounded]="true" (click)="clearAllNotifications()">
            <fa-icon [icon]="faTrash" />
        </button>
    </div>
</div>
